// English
import areaEN from './en/area.json';
import assetEN from './en/asset.json';
import colorsEN from './en/colors.json';
import daysEN from './en/days.json';
import frequencyEN from './en/frequency.json';
import howToUseEN from './en/howToUse.json';
import noDataEN from './en/noData.json';
import pagesEN from './en/pages.json';
import sectorEN from './en/sector.json';
import siteEN from './en/site.json';
import taskEN from './en/task.json';
import translationEN from './en/translation.json';
import validationEN from './en/validation.json';
import pluralsEN from './en/plurals.json';
// France
import areaFR from './fr/area.json';
import assetFR from './fr/asset.json';
import colorsFR from './fr/colors.json';
import daysFR from './fr/days.json';
import frequencyFR from './fr/frequency.json';
import howToUseFR from './fr/howToUse.json';
import noDataFR from './fr/noData.json';
import pagesFR from './fr/pages.json';
import sectorFR from './fr/sector.json';
import siteFR from './fr/site.json';
import taskFR from './fr/task.json';
import translationFR from './fr/translation.json';
import validationFR from './fr/validation.json';
import pluralsFR from './fr/plurals.json';
// Romania
import areaRO from './ro/area.json';
import assetRO from './ro/asset.json';
import colorsRO from './ro/colors.json';
import daysRO from './ro/days.json';
import frequencyRO from './ro/frequency.json';
import howToUseRO from './ro/howToUse.json';
import noDataRO from './ro/noData.json';
import pagesRO from './ro/pages.json';
import sectorRO from './ro/sector.json';
import siteRO from './ro/site.json';
import taskRO from './ro/task.json';
import translationRO from './ro/translation.json';
import validationRO from './ro/validation.json';
import pluralsRO from './ro/plurals.json';
// Ukraine
import areaUK from './uk/area.json';
import assetUK from './uk/asset.json';
import colorsUK from './uk/colors.json';
import daysUK from './uk/days.json';
import frequencyUK from './uk/frequency.json';
import howToUseUK from './uk/howToUse.json';
import noDataUK from './uk/noData.json';
import pagesUK from './uk/pages.json';
import sectorUK from './uk/sector.json';
import siteUK from './uk/site.json';
import taskUK from './uk/task.json';
import translationUK from './uk/translation.json';
import validationUK from './uk/validation.json';
import pluralsUK from './uk/plurals.json';
// Poland
import areaPL from './pl/area.json';
import assetPL from './pl/asset.json';
import colorsPL from './pl/colors.json';
import daysPL from './pl/days.json';
import frequencyPL from './pl/frequency.json';
import howToUsePL from './pl/howToUse.json';
import noDataPL from './pl/noData.json';
import pagesPL from './pl/pages.json';
import sectorPL from './pl/sector.json';
import sitePL from './pl/site.json';
import taskPL from './pl/task.json';
import translationPL from './pl/translation.json';
import validationPL from './pl/validation.json';
import pluralsPL from './pl/plurals.json';
// Spain
import areaES from './es/area.json';
import assetES from './es/asset.json';
import colorsES from './es/colors.json';
import daysES from './es/days.json';
import frequencyES from './es/frequency.json';
import howToUseES from './es/howToUse.json';
import noDataES from './es/noData.json';
import pagesES from './es/pages.json';
import sectorES from './es/sector.json';
import siteES from './es/site.json';
import taskES from './es/task.json';
import translationES from './es/translation.json';
import validationES from './es/validation.json';
import pluralsES from './es/plurals.json';

const resources = {
  en: {
    translation: {
      ...areaEN,
      ...assetEN,
      ...colorsEN,
      ...daysEN,
      ...frequencyEN,
      ...howToUseEN,
      ...noDataEN,
      ...pagesEN,
      ...sectorEN,
      ...siteEN,
      ...taskEN,
      ...translationEN,
      ...validationEN,
      ...pluralsEN,
    },
  },
  fr: {
    translation: {
      ...areaFR,
      ...assetFR,
      ...colorsFR,
      ...daysFR,
      ...frequencyFR,
      ...howToUseFR,
      ...noDataFR,
      ...pagesFR,
      ...sectorFR,
      ...siteFR,
      ...taskFR,
      ...translationFR,
      ...validationFR,
      ...pluralsFR,
    },
  },
  ro: {
    translation: {
      ...areaRO,
      ...assetRO,
      ...colorsRO,
      ...daysRO,
      ...frequencyRO,
      ...howToUseRO,
      ...noDataRO,
      ...pagesRO,
      ...sectorRO,
      ...siteRO,
      ...taskRO,
      ...translationRO,
      ...validationRO,
      ...pluralsRO,
    },
  },
  uk: {
    translation: {
      ...areaUK,
      ...assetUK,
      ...colorsUK,
      ...daysUK,
      ...frequencyUK,
      ...howToUseUK,
      ...noDataUK,
      ...pagesUK,
      ...sectorUK,
      ...siteUK,
      ...taskUK,
      ...translationUK,
      ...validationUK,
      ...pluralsUK,
    },
  },
  pl: {
    translation: {
      ...areaPL,
      ...assetPL,
      ...colorsPL,
      ...daysPL,
      ...frequencyPL,
      ...howToUsePL,
      ...noDataPL,
      ...pagesPL,
      ...sectorPL,
      ...sitePL,
      ...taskPL,
      ...translationPL,
      ...validationPL,
      ...pluralsPL,
    },
  },
  es: {
    translation: {
      ...areaES,
      ...assetES,
      ...colorsES,
      ...daysES,
      ...frequencyES,
      ...howToUseES,
      ...noDataES,
      ...pagesES,
      ...sectorES,
      ...siteES,
      ...taskES,
      ...translationES,
      ...validationES,
      ...pluralsES,
    },
  },
};

export default resources;
